import {Box, Typography} from '@mui/material';
import './TranscriptHeader.scss';
import {t} from 'i18next';
import ArrTooltipWrapper from '../../../../common/arr-tooltip-wrapper/ArrTooltipWrapper';
import {ReactComponent as InfoIcon} from '../../../../../assets/images/info-icon.svg';
import TranscriptHeaderAction from '../../common/TranscriptHeaderAction';
import {Trans} from 'react-i18next';

interface HeaderProps {
  onNewChatClick?: () => void;
  onCollapseClick?: () => void;
  disableNewChat?: boolean;
}
const TranscriptHeader: React.FC<HeaderProps> = ({
  onNewChatClick,
  onCollapseClick,
  disableNewChat = true,
}) => {
  return (
    <Box className="transcript-header-wrapper">
      <Box className="header-container">
        <Typography
          className="header-title typo-text subhead5_size"
          data-testid="transcript-panel-header"
          component="span"
        >
          {t('ai.investigate.transcripts.title')}
          <ArrTooltipWrapper
            title={t('ai.investigate.transcripts.title')}
            trigger={
              <InfoIcon
                className="view-user-info-icon"
                data-testid="transcript-info-tooltip"
              />
            }
            placement="right"
          >
            <Trans
              i18nKey="ai.investigate.transcripts.tooltip.tt0"
              components={{
                br: (
                  <br data-testid="ai-investigate-transcript-header-tooltip-br" />
                ),
                strong: (
                  <strong data-testid="ai-investigate-transcript-header-tooltip-strong" />
                ),
                p: (
                  <p data-testid="ai-investigate-transcript-header-tooltip-p" />
                ),
              }}
            />
          </ArrTooltipWrapper>
        </Typography>

        <Box className="header-actions">
          <TranscriptHeaderAction
            onNewChatClick={onNewChatClick}
            onCollapseClick={onCollapseClick}
            disableNewChat={disableNewChat}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default TranscriptHeader;
